export const GET_ICEPACKS_FILLERS = 'icepacks-fillers/GET_ICEPACKS_FILLERS';
export const getIcepacksFillersAction = payload => ({
	type: GET_ICEPACKS_FILLERS,
	payload,
});

export const SET_ICEPACKS_FILLERS = 'icepacks-fillers/SET_ICEPACKS_FILLERS';
export const setIcepacksFillersAction = payload => ({
	type: SET_ICEPACKS_FILLERS,
	payload,
});

export const SET_PAGINATION = 'icepacks-fillers/SET_PAGINATION';
export const setPaginationAction = payload => ({
	type: SET_PAGINATION,
	payload,
});

export const SET_IS_ICEPACKS_FILLERS_LOADING = 'icepacks-fillers/SET_IS_ICEPACKS_FILLERS_LOADING';
export const setIsIcepacksFillersLoadingAction = payload => ({
	type: SET_IS_ICEPACKS_FILLERS_LOADING,
	payload,
});

export const RESET_STATE = 'icepacks-fillers/RESET_STATE';
export const resetStateAction = () => ({
	type: RESET_STATE,
});
